import type { YourWorkFilters } from '../@types';

/**
 * Get set of strings for rendering
 * @param yourWorkFiltersOptions
 * @returns {Set} string set for chips
 */
export const getSelectedFiltersForChips = (yourWorkFiltersOptions: YourWorkFilters = []): Set<string> => {
	let chips: Array<string> = [];
	yourWorkFiltersOptions.forEach((filterOption) => {
		if (filterOption.selectedOption) {
			chips.push(filterOption.selectedOption);
		}
		if (filterOption.selectedOptions) {
			chips = chips.concat(...Array.from(filterOption.selectedOptions));
		}
	});
	const chipSet = new Set(chips);
	chipSet.delete('all');

	return chipSet;
};
